import React from "react";
import "./header.css";
import logo from "../../images/logo2.png";
const Header = () => {
  return (
    <header>
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">
              {/* <img src="images/logo.png" className="light_logo" alt="Light Logo" />
                    <img src="images/darklogo.png" className="black_logo" alt="Dark Logo" /> */}
              <img src={logo} className="light_logo" alt="Logo 2" />
              {/* <img src="images/darklogo2.png" className="black_logo" alt="Dark Logo 2" /> */}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="fa fa-bars" aria-hidden="true"></i>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link" href="/">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#about">
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#our_fleet">
                    Our Fleet
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#services">
                    Our Services
                  </a>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="/#contact">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};
export default Header;
